import { useTranslation } from '@framework/i18n';
import { Collapse } from 'antd';
import clx from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { SearchFormContainer } from './SearchFormContainer';

const CollapseHiddenTitle = styled(Collapse)`
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    display: none;
  }
`;
const CollapsePanel = styled(Collapse.Panel)`
  &.no-padding {
    .ant-collapse-content-box {
      padding: 0;
    }
  }
  .ant-collapse-content-box {
    /* background-color: ${props => props.theme.colorBgContainer};
    border-radius: 0 0 4px 4px; */
  }
`;

export interface IGhostCollapseProps
  extends React.HTMLAttributes<HTMLDivElement> {
  opened: boolean;
  button: React.ReactNode;
  noPadding?: boolean;
}

/*
 * Collepse nascosto per mostrare elementi dinamici
 *
 */
export function GhostCollapse(props: IGhostCollapseProps) {
  const { opened, children, button, noPadding, ...divProps } = props;
  const { t } = useTranslation();

  return (
    <div {...divProps}>
      <CollapseHiddenTitle activeKey={[opened ? 'opened' : '']} ghost>
        <CollapsePanel
          header={t(
            'collapse.ghost-collapse.header',
            'Ghost Extend Collapse',
          )}
          key="opened"
          className={clx({ 'no-padding': noPadding })}
        >
          <SearchFormContainer button={button}>{children}</SearchFormContainer>
        </CollapsePanel>
      </CollapseHiddenTitle>
    </div>
  );
}
